var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"button",attrs:{"dark":"","loading":_vm.loading},on:{"click":_vm.trigger}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }